import { makeStyles } from '@material-ui/core';
import { createFactoryStyles } from '../../../common/ui/styles/helpers';
import { pipelineStyles } from '../../common/styles';
export const useStyles = makeStyles(({ factory: factoryTheme }) => {
    return createFactoryStyles({
        ...pipelineStyles({ factoryTheme }),
    });
});
